import { CollideEvent, CollideId } from '../../defs/collide';
import {
  despawnBlockEntity,
  spawnBlockEntity,
  WormBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class WormCollision implements ICollision {
  private readonly _scene: GameScene;
  private readonly _entity: WormBlockEntity;
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  constructor(scene: GameScene, entity: WormBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  private async _resolveTap() {
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    await this._attack();
    return true;
  }

  private async _resolveAttack() {
    await this._attack();
    return true;
  }

  private async _attack() {
    this._entity.c.blockWorm.view.stopAnimation();
    const position = this._entity.c.position.mapPosition;

    // destroy the worm and replace with a cocoon
    despawnBlockEntity(this._scene, this._entity);
    spawnBlockEntity(this._scene, { id: 'cocoon' }, position);
  }
}
